import { allowedImageFormats } from '@showbie-socrative/socrative-utils';

import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

import { EventAdapter } from './EventAdapter';
import { ImageAddMethod, ImageUploadContext } from './ImageEventAdapterTypes';

interface ImageFormatUnsupportedAdapterParams {
  file_type: string;
  file_size: number;
  width: number;
  height: number;
  context?: ImageUploadContext;
  add_method?: ImageAddMethod;
  allowed_image_formats: Array<string>;
}

export class UnsupportedImageFormatEventAdapter extends EventAdapter<ImageFormatUnsupportedAdapterParams> {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendImageFormatUnsupportedEvent;

  constructor({
    context,
    add_method,
    file_type,
    file_size,
    width,
    height,
  }: Omit<ImageFormatUnsupportedAdapterParams, 'allowed_image_formats'>) {
    super();

    try {
      this.eventData = {
        file_type,
        file_size,
        context,
        add_method,
        width,
        height,
        allowed_image_formats: allowedImageFormats as any,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}

function sendImageFormatUnsupportedEvent(
  data: ImageFormatUnsupportedAdapterParams
) {
  sendTeacherAmplitudeEvent(EventTypes.ImageFormatUnsupported, data);
}
